import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'

import { createDataModelEffects } from './data-model.effects'

import { TemplateDataModelApiService } from '../../api/template-data-model.api'
import { NotificationTemplateDataModelActions } from '../actions/template-data-model.actions'

const notificationTemplateDataModelBasicEffects = createDataModelEffects(
  ApplicationResourceType.NotificationTemplate,
  {
    load: NotificationTemplateDataModelActions.loadEntities,
    loadSuccess: NotificationTemplateDataModelActions.loadEntitiesSuccess,
    loadFailure: NotificationTemplateDataModelActions.loadEntitiesFailure,
    add: NotificationTemplateDataModelActions.addEntity,
    addSuccess: NotificationTemplateDataModelActions.addEntitySuccess,
    addFailure: NotificationTemplateDataModelActions.addEntityFailure,
    edit: NotificationTemplateDataModelActions.editEntity,
    editSuccess: NotificationTemplateDataModelActions.editEntitySuccess,
    editFailure: NotificationTemplateDataModelActions.editEntityFailure,
    addAttribute: NotificationTemplateDataModelActions.addAttribute,
    addAttributeSuccess: NotificationTemplateDataModelActions.addAttributeSuccess,
    addAttributeFailure: NotificationTemplateDataModelActions.addAttributeFailure,
    editAttribute: NotificationTemplateDataModelActions.editAttribute,
    editAttributeSuccess: NotificationTemplateDataModelActions.editAttributeSuccess,
    editAttributeFailure: NotificationTemplateDataModelActions.editAttributeFailure,
    requestDeleteEntity: NotificationTemplateDataModelActions.deleteEntityRequested,
    deleteEntity: NotificationTemplateDataModelActions.deleteEntity,
    deleteEntitySuccess: NotificationTemplateDataModelActions.deleteEntitySuccess,
    deleteEntityFailure: NotificationTemplateDataModelActions.deleteEntityFailure,
    requestDeleteAttribute: NotificationTemplateDataModelActions.deleteAttributeRequested,
    deleteAttribute: NotificationTemplateDataModelActions.deleteAttribute,
    deleteAttributeSuccess: NotificationTemplateDataModelActions.deleteAttributeSuccess,
    deleteAttributeFailure: NotificationTemplateDataModelActions.deleteAttributeFailure,
    resetErrors: NotificationTemplateDataModelActions.resetErrors,
    resetErrorsSuccess: NotificationTemplateDataModelActions.resetErrorsSuccess,
    updateAttributeValidators: NotificationTemplateDataModelActions.updateAttributeValidators,
    updateAttributeValidatorsSuccess:
      NotificationTemplateDataModelActions.updateAttributeValidatorsSuccess,
    updateAttributeValidatorsFailure:
      NotificationTemplateDataModelActions.updateAttributeValidatorsFailure,
  },
  TemplateDataModelApiService
)

export const notificationTemplateAddEntity$ = notificationTemplateDataModelBasicEffects.addEntity$
export const notificationTemplateEditEntity$ = notificationTemplateDataModelBasicEffects.editEntity$
export const notificationTemplateAddAttribute$ =
  notificationTemplateDataModelBasicEffects.addAttribute$
export const notificationTemplateEditAttribute$ =
  notificationTemplateDataModelBasicEffects.editAttribute$
export const notificationTemplateSetNewEntityAsAttribute$ =
  notificationTemplateDataModelBasicEffects.setNewEntityAsAttribute$
export const notificationTemplateStartDeleteEntity$ =
  notificationTemplateDataModelBasicEffects.startDeleteEntity$
export const notificationTemplateDeleteEntity$ =
  notificationTemplateDataModelBasicEffects.deleteEntity$
export const notificationTemplateStartDeleteAttribute$ =
  notificationTemplateDataModelBasicEffects.startDeleteAttribute$
export const notificationTemplateDeleteAttribute$ =
  notificationTemplateDataModelBasicEffects.deleteAttribute$
export const notificationTemplateResetErrors$ =
  notificationTemplateDataModelBasicEffects.resetErrors$
export const notificationTemplateUpdateAttributeValidators$ =
  notificationTemplateDataModelBasicEffects.updateAttributeValidators$
